export const dataModalFreightRegisterSharing = {
  title: 'Compartilhe fretes com mais motoristas!',
  subtitle: 'Com seu plano atual, seus fretes estão sendo compartilhados com um número reduzido de motoristas.',
  video: 'https://uploads.fretebras.com.br/nca-videos/motoristas-sugeridos.webm',
  whatsappMessage:
    'Olá, meu plano atual não possui acesso a feature "Compartilhar Fretes". Gostaria de mudar meu plano e obter acesso',
};

export const dataByProduct = {
  'freight-register-sharing': {
    ...dataModalFreightRegisterSharing,
  },
};
